/**
 * Histopathology Billing – Cash Counter (dummy screen).
 */
import React from "react";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";

export default function CashCounter() {
  return (
    <Box sx={{ p: 2 }}>
      <Typography variant="h6" color="text.secondary">Histopathology – Cash Counter</Typography>
    </Box>
  );
}
